module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/2236772ef59600810e73fa7bb49ab15d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/svg/Mathletics.svg
// module id = +cV+
// module chunks = 0